<section class="hab" role="region" aria-label="BB’s habitat">

  <header class="hab__head">
    <button type="button" class="hab__back" aria-label="Back to chat" (click)="closed.emit()">←</button>
    <span class="hab__title">BB’s habitat</span>
    <span class="hab__stage">Lv {{ progress.level }} · {{ progress.stageLabel }}</span>
  </header>

  <!-- The scene. Props appear as levels unlock them, so progress reads even at rest. -->
  <div class="hab__scene">
    <span class="hab__spark hab__spark--1" aria-hidden="true"></span>
    <span class="hab__spark hab__spark--2" aria-hidden="true"></span>

    <span class="hab__prop hab__prop--shelf" *ngIf="hasProp('shelf')" aria-hidden="true"></span>
    <span class="hab__prop hab__prop--shelf-item" *ngIf="hasProp('shelf')" aria-hidden="true"></span>
    <span class="hab__prop hab__prop--plant" *ngIf="hasProp('plant')" aria-hidden="true"></span>
    <span class="hab__prop hab__prop--lamp" *ngIf="hasProp('lamp')" aria-hidden="true"></span>
    <span class="hab__prop hab__prop--window" *ngIf="hasProp('window')" aria-hidden="true"></span>

    <div class="hab__bb">
      <app-bb-mascot [state]="bbState" [stage]="progress.stage" [size]="86" [decorative]="true"></app-bb-mascot>
    </div>

    <span class="hab__fade" aria-hidden="true"></span>
    <span class="hab__caption">{{ habitatLine }}</span>
  </div>

  <div class="hab__body">

    <!-- Level -->
    <div class="hab__block">
      <div class="hab__block-head">
        <span class="hab__block-title">Level {{ progress.level }} → {{ progress.level + 1 }}</span>
        <span class="hab__block-value hab__block-value--xp">{{ progress.xpIntoLevel }} / {{ progress.xpForLevel }} XP</span>
      </div>
      <div class="hab__track"><div class="hab__fill hab__fill--xp" [style.width.%]="xpPct"></div></div>
      <p class="hab__note">{{ nextUnlockLine }}</p>
    </div>

    <!-- Streak -->
    <div class="hab__block">
      <div class="hab__block-head">
        <span class="hab__block-title">Streak</span>
        <span class="hab__block-value hab__block-value--streak">
          {{ progress.streakDays }} days · {{ progress.multiplier }}× XP
        </span>
      </div>
      <div class="hab__week">
        <span
          class="hab__day"
          *ngFor="let day of progress.week; trackBy: trackDay"
          [class.hab__day--hit]="day.state === 'hit'"
          [class.hab__day--today]="day.state === 'today'"
          [class.hab__day--frozen]="day.state === 'frozen'"
        >
          {{ day.state === 'frozen' ? '❄' : day.label }}
        </span>
      </div>
      <p class="hab__note">{{ freezeLine }}</p>
    </div>

    <!-- Weekly challenge -->
    <div class="hab__challenge">
      <div class="hab__block-head">
        <span class="hab__challenge-title">This week’s challenge</span>
        <span class="hab__challenge-xp">+{{ progress.challenge.xp }}</span>
      </div>
      <p class="hab__challenge-body">{{ progress.challenge.label }}</p>
      <div class="hab__challenge-foot">
        <div class="hab__track hab__track--slim"><div class="hab__fill hab__fill--action" [style.width.%]="challengePct"></div></div>
        <span class="hab__challenge-count">
          {{ progress.challenge.done }}/{{ progress.challenge.total }} · {{ progress.challenge.daysLeft }}d left
        </span>
      </div>
    </div>

    <!-- Badges -->
    <div class="hab__block">
      <div class="hab__block-head">
        <span class="hab__block-title">Badges</span>
        <span class="hab__block-value">{{ unlockedBadges }} of {{ progress.badges.length }}</span>
      </div>
      <div class="hab__badges">
        <button
          type="button"
          class="hab__badge"
          *ngFor="let badge of badgeGrid; trackBy: trackBadge"
          [class.hab__badge--locked]="!badge.unlocked"
          [style.color]="badge.unlocked ? accentFor(badge) : null"
          [style.background]="badge.unlocked ? tintFor(badge) : null"
          [attr.aria-label]="badge.unlocked ? badge.label + ' — unlocked' : badge.label + ' — locked: ' + badge.condition"
          (click)="toggleBadge(badge)"
        >
          {{ badge.glyph }}
        </button>
      </div>
      <p class="hab__note">{{ revealedCondition || 'Locked badges show their unlock condition on tap' }}</p>
    </div>
  </div>
</section>
